/**
 * Dynamically hide/show the mobile action bar.
 */

var $ = require('jquery');
var Modernizr = require('Modernizr');

module.exports = {
    elements: {
        // Cached jQuery wrapper for the spacer.
        // This is used to reserve page space for the bar in certain circumstances.
        spacer: null,
        // Cached jQuery wrapper for the bar object.
        bar: null,
        // Cached jQuery wrapper for the window object.
        $window: null
    },

    dimensions: {
        // The height of the bar. Will be set to detected height in init().
        barHeight: null,
        // How many pixels the bar is currently pushed behind the bottom of the page.
        // The code will cap this to [0, height]. Is applied as negative CSS bottom.
        barDisplacement: 0,
        // Record the previous scroll position of the page, so we can tell whether
        // we're scrolling up or down and by how much. First value set by init().
        prevWindowScroll: null,
        // Record the previous height of the viewport, so we can tell when it
        // changes and put a temporary hold on positioning calculations.
        prevViewportHeight: null
    },

    events: {
        // Scroll event counter. Serves for event throttling, so we don't run more
        // than a certain amount of updates per second.
        counter: 0,
        // Maximum bar updates per second.
        fps: 60
    },

    /**
     * Updates the position of the bar with scroll delta since last update.
     */
    update: function () {
        // fetch current positions
        var viewportHeight = this.elements.$window.height();
        var windowScroll = this.elements.$window.scrollTop();
        // determine how much the page scrolled since last update
        var scrollDelta = windowScroll - this.dimensions.prevWindowScroll;

        var skipThisUpdate = false;
        // don't update if page hasn't scrolled (the update may be have been
        // called from places other than the scroll event)
        if (scrollDelta === 0) {
            skipThisUpdate = true;
        }
        // if viewport height has changed all bets are off, don't update
        // XXX also workaround for [DHDIY-27320] iOS Safari bottom browser bar
        if (viewportHeight !== this.dimensions.prevViewportHeight) {
            skipThisUpdate = true;
        }

        // the new positions must be recorded regardless
        this.dimensions.prevWindowScroll = windowScroll;
        this.dimensions.prevViewportHeight = viewportHeight;

        if (skipThisUpdate) {
            return;
        }

        // compute bar displacement, and cap it to [0,height]
        this.dimensions.barDisplacement = Math.max(
            0,
            Math.min(this.dimensions.barHeight, this.dimensions.barDisplacement + scrollDelta)
        );

        // the displacement is applied as negative bottom absolute position
        this.elements.bar.css({'bottom': (-1 * this.dimensions.barDisplacement) + 'px'});
    },

    /**
     * This will hook the scroll event and update the bar position.
     * It MUST only be called once, from init().
     */
    initUpdateMechanism: function () {
        this.events.counter = 0;
        window.addEventListener('scroll', function () {
            // the counter is updated with every scroll event
            this.events.counter++;
            // only the 1st event in a consecutive series makes it
            // past this point and triggers an update; the others are ignored
            if (this.events.counter > 1) {
                return;
            }
            this.update();
            // we schedule a function to be run later, after an interval which
            // is calculated to produce an update frequency of no more than the
            // desired FPS; during this interval, no updates are run
            window.setTimeout(function () {
                // at the end of the delay interval, we do one more update if
                // there was at least one other scroll event in the meantime
                if (this.events.counter > 2) {
                    this.update();
                }
                // then we finally reset the counter so the cycle can start again
                this.events.counter = 0;
            }.bind(this), Math.floor(1000 / this.events.fps));
        }.bind(this));
    },

    /**
     * Run this to set up this object and start processing scroll events.
     */
    init: function () {
        // references to relevant DOM elements
        this.elements.$window = $(window);
        this.elements.spacer = $('#mobile-infobar-spacer');
        this.elements.bar = $('#mobile-infobar');

        //FIXME: DHDIY-27320: disable scrolling on iOS until a workaround is found for Safari bottom browser bar
        if (/iPad|iPhone|iPod/.test(navigator.platform)) {
            //XXX: DHDIY-33077: need the spacer, to avoid overlapping useful content
            this.elements.spacer.show();
            return;
        }

        // bail out if not on a real touch device
        if (!(Modernizr.touch)) {
            return;
        }
        //XXX: don't try to activate this for mobilepreview, the fake scrollbars don't emit scroll events

        // the bar may not have been rendered, for lack of necessary data
        if (!(this.elements.spacer.length && this.elements.bar.length)) {
            return;
        }

        // init internal vars
        this.dimensions.barHeight = this.elements.bar.height();
        this.dimensions.prevWindowScroll = this.elements.$window.scrollTop();
        this.dimensions.prevViewportHeight = this.elements.$window.height();

        // add a spacer if the document is smaller than the viewport,
        // to make sure the bar doesn't obscure any page content
        if ($(document).height() <= this.dimensions.prevViewportHeight) {
            this.elements.spacer.show();
        }

        // trigger mechanism to react to scroll periodically
        (this.initUpdateMechanism.bind(this))();
    }
};



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/mobilebar/web.js
 ** module id = 1210
 ** module chunks = 12
 **/